import { t } from "../i18n";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./useAuth";
import { OptionsPage } from "../features/admin/OptionsPage";

/** /hesap — Seçenekler penceresinin "Hesap" kategorisi (README §4.2); misafir girişe yönlenir. */
export function AccountPage(): JSX.Element {
  const nav = useNavigate();
  const { status } = useAuth();
  useEffect(() => { if (status === "guest" || status === "no-api") nav("/giris"); }, [status, nav]);
  if (status !== "authed") return <p className="p-6 text-stone">{t("Yükleniyor…")}</p>;
  return <OptionsPage initial="account" />;
}
